<template>
  <BasicTemplate>
    <h3>
      <router-link to="/feeds">Feeds</router-link> /
      Feed {{ $route.params.id === 'new' ? 'new' : '#' + $route.params.id }}
    </h3>
    <FeedForm :games="games" :meta-templates="metaTemplates" :item="item" @change="loadItem()" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../templates/basic.vue';
import FeedForm from './form.vue';

export default {
  name: 'FeedEdit',
  components: { BasicTemplate, FeedForm },
  data() {
    return {
      item: null,
      games: [],
      metaTemplates: [],
      feedGamesHeaders: [
        { text: 'Id', value: 'game.id' },
        { text: 'Slug', value: 'game.slug' },
        { text: 'Name', value: 'game.name' },
        { text: 'Actions', value: 'actions', align: 'center' },
      ],
    };
  },
  async created() {
    this.$watch(() => this.$route.params, (newParams, prevParams) => this.loadItem());
    await this.loadItem();
  },
  methods: {
    async loadItem() {
      const { id } = this.$route.params;

      const [item, games, metaTemplates] = await Promise.all([
        id !== 'new' ? this.$gameApi.get(`/feeds/${id}?short=true`) : Promise.resolve({ feedGames: [] }),
        this.$gameApi.get('/games'),
        this.$gameApi.get('/meta-templates'),
      ]);

      this.games = games;
      const list = Array.isArray(metaTemplates) ? metaTemplates : (metaTemplates?.items || metaTemplates?.data || []);
      this.metaTemplates = list
        .slice()
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }));
      this.item = item;
    },
  }
};
</script>

